class ReFetch {
  constructor(url, { body, jsonAPI = false, method = 'POST', accept, mimeType }) {
    this.url = url
    this.body = body ? JSON.stringify(body) : null
    this.method = method
    this.jsonAPI = jsonAPI
    this.accept = accept
    this.mimeType = mimeType
  }

  callWithToken(token) {
    return fetch(this.url, {
      method: this.method,
      headers: this.headers(token),
      body: this.body,
    })
  }

  headers(token) {
    let mimeType = null

    if (!this.mimeType) mimeType = this.jsonAPI ? 'application/vnd.api+json' : 'application/json'

    const reducer = (accumulator, currentValue) =>
      currentValue ? `${accumulator}, ${currentValue}` : accumulator

    let output = {
      'Content-Type': this.mimeType || mimeType,
      Accept: [this.mimeType || mimeType, this.accept].reduce(reducer),
    }

    if (token) output['Authorization'] = `Bearer ${token}`

    return output
  }
}

export default ReFetch



// WEBPACK FOOTER //
// ./src/authorisation/fetch-with-retry/refetch.js